import love_it from './stareyes_40x40.gif';
import confused from './confused_40x40.gif';
import frustrated from './disappointed_40x40.gif';

export const Images = {
    love_it,
    confused,
    frustrated,
};
